// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";

const metadata: BuiltInScriptMetadata = {
  name: "Projectile Ground Pulse",
  id: "projectile-ground-pulse",
  metadata: {
    imports: ["projectile","vector","self"],
    icon: {
      "backgroundColor": 2297646,
      "layers": [
        {
          "iconKey": "fireball",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -13,
          "color": 5304063
        }
      ]
    },
  },
};

export default metadata;
